import { compose, withProps } from 'recompose'
import { NavLink } from 'react-router-dom'
import omitProps from 'src/composables/omitProps'
import withComposedClassName from 'src/composables/withComposedClassName'
import Button from 'src/Components/shared/Button'
import styles from './Navigation.module.scss'

const UnstyledLink = compose(
  withComposedClassName(({ active }) => active && styles.active),
  omitProps('active'),
  withProps({ element: NavLink })
)(Button)

export const SubHomebotNav = withComposedClassName(styles.sublink)(UnstyledLink)
